import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const raftstoreSchema: Schema = {
  title: 'Raftstore',
  level: 2,
  columns: commonColumns
}
